/* Utility: escape HTML to prevent injection */
function rtcEsc(str) {
  var d = document.createElement('div');
  d.appendChild(document.createTextNode(str));
  return d.innerHTML;
}

/* Cached global DOM refs */
var _headerWrapper = null;
var _themeHeader = null;
function rtcHeader() {
  if (!_headerWrapper) _headerWrapper = document.querySelector('.header__wrapper');
  return _headerWrapper;
}
function rtcThemeHeader() {
  if (!_themeHeader) _themeHeader = document.querySelector('.theme__header') || document.querySelector('.header__wrapper');
  return _themeHeader;
}

/* Utility: wait for a DOM element to appear, then run callback */
function rtcWaitFor(selector, callback, timeout) {
  var el = document.querySelector(selector);
  if (el) { callback(el); return; }
  var obs = new MutationObserver(function(_, o) {
    var el = document.querySelector(selector);
    if (el) { o.disconnect(); callback(el); }
  });
  obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  if (timeout) { setTimeout(function() { obs.disconnect(); }, timeout); }
}

      try { (function() {
        /* Desktop grid toggle (3/4 columns) */
        var btns = document.querySelectorAll('[data-rtc-grid]');
        btns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            var cols = btn.getAttribute('data-rtc-grid');
            var grid = document.querySelector('.collection-products');
            if (!grid) return;
            btns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
            if (cols === '3') {
              grid.classList.add('rtc-grid-3');
            } else {
              grid.classList.remove('rtc-grid-3');
            }
          });
        });

        /* Mobile grid toggle (1/2 columns) */
        var mobileBtns = document.querySelectorAll('[data-rtc-mobile-grid]');
        mobileBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            var cols = btn.getAttribute('data-rtc-mobile-grid');
            var grid = document.querySelector('.collection-products');
            if (!grid) return;
            mobileBtns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
            if (cols === '1') {
              grid.classList.add('rtc-mobile-grid-1');
            } else {
              grid.classList.remove('rtc-mobile-grid-1');
            }
          });
        });

        /* Mobile sort button — trigger Broadcast's sort */
        var mobileSort = document.querySelector('[data-rtc-mobile-sort]');
        if (mobileSort) {
          mobileSort.addEventListener('click', function() {
            var sortBtn = document.querySelector('.collection__nav .popout--sort .popout__toggle');
            if (sortBtn) sortBtn.click();
          });
        }
      })(); } catch(e) { console.warn('RTC: grid-toggle failed', e); }


/* Product-image slide counter (1/2, 2/2, etc.) — mobile + desktop */
try { (function() {
  if (!document.body.classList.contains('template-product')) return;

  var slides = document.querySelector('.product__slides');
  if (!slides) return;

  var slideEls = slides.querySelectorAll('.product__slide');
  var total = slideEls.length;
  if (total < 2) return;

  // Create counter on product-images (parent) so it doesn't scroll with slides
  var productImages = slides.closest('product-images') || slides.parentElement;
  var counter = document.createElement('span');
  counter.className = 'rtc-slide-counter';
  counter.textContent = '1 / ' + total;
  productImages.appendChild(counter);

  var ticking = false;

  function updateCounter() {
    if (window.innerWidth < 750) {
      // Mobile: use scroll position to find visible slide
      var containerLeft = slides.getBoundingClientRect().left;
      var containerCenter = containerLeft + slides.offsetWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      for (var i = 0; i < slideEls.length; i++) {
        var rect = slideEls[i].getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenter - containerCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      }
      counter.textContent = (closest + 1) + ' / ' + total;
    } else {
      // Desktop: find the active media slide
      var active = slides.querySelector('.media--active') || slides.querySelector('.product__slide:not(.media--hidden)');
      if (active) {
        var idx = Array.from(slideEls).indexOf(active);
        if (idx >= 0) {
          counter.textContent = (idx + 1) + ' / ' + total;
        }
      }
    }
    ticking = false;
  }

  // Mobile scroll
  slides.addEventListener('scroll', function() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateCounter);
    }
  }, { passive: true });

  // Desktop thumbnail clicks + arrow clicks
  document.addEventListener('theme:media:select', function() {
    setTimeout(updateCounter, 50);
  });

  // Also catch clicks on thumbs directly
  var thumbs = document.querySelectorAll('.product__thumb__link');
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() {
      setTimeout(function() {
        counter.textContent = (i + 1) + ' / ' + total;
      }, 50);
    });
  });

  // Catch arrow button clicks
  var arrows = document.querySelectorAll('.slider__button--prev, .slider__button--next');
  arrows.forEach(function(arrow) {
    arrow.addEventListener('click', function() {
      setTimeout(updateCounter, 100);
    });
  });
})(); } catch(e) { console.warn('RTC: slide-counter failed', e); }


/* Auto-show correct variant image when ?variant= is in the URL */
try { (function() {
  if (!document.body.classList.contains('template-product')) return;
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  if (!variantId) return;

  // Wait for product-images to be ready
  rtcWaitFor('product-images', function() {
    // Find the variant's featured image in the product JSON
    var scriptEl = document.querySelector('product-images script[type="application/json"], [data-product-json]');
    var productData = null;
    if (scriptEl) {
      try { productData = JSON.parse(scriptEl.textContent); } catch(e) {}
    }

    // Find the variant
    var variant = null;
    if (productData && productData.variants) {
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === variantId) {
          variant = productData.variants[i];
          break;
        }
      }
    }

    if (!variant || !variant.featured_media) return;
    var mediaId = variant.featured_media.id;

    // Find the slide with this media ID and activate it
    var slides = document.querySelectorAll('.product__slide[data-image-id]');
    for (var j = 0; j < slides.length; j++) {
      var slideMediaId = slides[j].getAttribute('data-image-id');
      if (String(slideMediaId) === String(mediaId)) {
        // Hide all slides, show this one
        slides.forEach(function(s) {
          s.classList.remove('media--active');
          s.classList.add('media--hidden');
        });
        slides[j].classList.remove('media--hidden');
        slides[j].classList.add('media--active');

        // On mobile, scroll the slides container to this slide
        if (window.innerWidth < 750) {
          var slidesContainer = slides[j].closest('.product__slides');
          if (slidesContainer) {
            slidesContainer.scrollTo({ left: slides[j].offsetLeft, behavior: 'instant' });
          }
        }

        // Update thumbnail active state
        var thumbs = document.querySelectorAll('.product__thumb');
        thumbs.forEach(function(t, idx) {
          t.classList.toggle('is-active', idx === j);
        });

        // Update slide counter if it exists
        var counter = document.querySelector('.rtc-slide-counter');
        if (counter) {
          counter.textContent = (j + 1) + ' / ' + slides.length;
        }

        break;
      }
    }
  }, 5000);
})(); } catch(e) { console.warn('RTC: variant-image-select failed', e); }

/* Auto-select single size variant */
try { (function() {
  if (!document.body.classList.contains('template-product')) return;
  var sizeWrappers = document.querySelectorAll('.selector-wrapper--size');
  sizeWrappers.forEach(function(wrapper) {
    var buttons = wrapper.querySelectorAll('.radio__button');
    if (buttons.length === 1) {
      var input = buttons[0].querySelector('input[type="radio"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})(); } catch(e) { console.warn('RTC: auto-select single size failed', e); }


/* RTC Desktop Section Snap — product ↔ kit builder */
try { (function() {
  if (window.innerWidth < 750) return;
  if (!document.body.classList.contains('template-product')) return;

  var kit = document.getElementById('rtc-kit-builder');
  if (!kit) return;

  var isSnapping = false;
  var currentSection = 'product';
  var freezeZone = false;
  var wheelAccum = 0;
  var wheelTimer = null;
  var SNAP_THRESHOLD = 80;   // accumulated delta before snap fires
  var FREEZE_ZONE = 300;      // px from boundary to start freezing scroll

  function getKitTop() {
    return window.scrollY + kit.getBoundingClientRect().top;
  }

  function getHeaderHeight() {
    var h = rtcThemeHeader();
    return h ? h.offsetHeight : 0;
  }

  function snapTo(section) {
    if (isSnapping) return;
    isSnapping = true;
    currentSection = section;
    wheelAccum = 0;

    var y = 0;
    if (section === 'kit') {
      y = getKitTop() - getHeaderHeight();
    }

    window.scrollTo({ top: y, behavior: 'smooth' });
    setTimeout(function() { isSnapping = false; }, 1000);
  }

  window.addEventListener('wheel', function(e) {
    // Let pinch-to-zoom through (ctrlKey is set on trackpad pinch gestures)
    if (e.ctrlKey) return;
    if (isSnapping) { e.preventDefault(); return; }

    var scrollY = window.scrollY;
    var vh = window.innerHeight;
    var kitTopPos = getKitTop();
    var headerH = getHeaderHeight();

    // --- Scrolling DOWN on product section ---
    if (e.deltaY > 0 && currentSection === 'product') {
      var distanceToKit = kitTopPos - (scrollY + vh);

      // Inside freeze zone — block normal scroll, accumulate intent
      if (distanceToKit < FREEZE_ZONE) {
        e.preventDefault();
        wheelAccum += Math.abs(e.deltaY);

        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function() { wheelAccum = 0; }, 300);

        if (wheelAccum >= SNAP_THRESHOLD) {
          snapTo('kit');
        }
        return;
      }
    }

    // --- Scrolling UP on kit section ---
    // Only snap back when user is at the very top of the kit (can't scroll up further)
    if (e.deltaY < 0 && currentSection === 'kit') {
      var kitSnapPoint = kitTopPos - headerH - 1;
      var distanceIntoKit = scrollY - kitSnapPoint;

      // User is at the top of the kit section (within 5px)
      if (distanceIntoKit <= 5) {
        // First, lock scroll position so page doesn't move
        window.scrollTo({ top: kitSnapPoint });
        e.preventDefault();
        wheelAccum += Math.abs(e.deltaY);

        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function() { wheelAccum = 0; }, 300);

        if (wheelAccum >= SNAP_THRESHOLD) {
          snapTo('product');
        }
        return;
      }
    }

    // Outside boundary zones — reset accumulator
    wheelAccum = 0;
  }, { passive: false });

  // Track which section user is in
  window.addEventListener('scroll', function() {
    if (isSnapping) return;
    var scrollY = window.scrollY;
    var kitSnapPoint = getKitTop() - getHeaderHeight();

    if (scrollY >= kitSnapPoint - 20) {
      currentSection = 'kit';
    } else {
      currentSection = 'product';
    }
  }, { passive: true });
})(); } catch(e) { console.warn('RTC: section-snap failed', e); }

/* RTC Mobile Product Page — rearrange DOM */
try { (function() {
  if (window.innerWidth > 749) return;
  if (!document.body.classList.contains('template-product')) return;

  function rearrangeMobile(formWidth) {
    // Move Shop Pay installment text up under the price block
    var shopPayTerms = formWidth.querySelector('.shop-pay-terms');
    var priceBlock = formWidth.querySelector('.product__head + .product__block');
    if (shopPayTerms && priceBlock) {
      priceBlock.after(shopPayTerms);
    }
  }

  rtcWaitFor('.form__width', rearrangeMobile, 10000);
})(); } catch(e) { console.warn('RTC: mobile-rearrange failed', e); }

/* Set header height CSS variable for sticky summary */
try { (function() {
  function setHeaderHeight() {
    var h = rtcThemeHeader();
    if (h) {
      document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight);
  } else {
    setHeaderHeight();
  }
  window.addEventListener('resize', setHeaderHeight);

  // Toggle header style on scroll (transparent at top, solid when scrolling)
  var headerWrapper = rtcHeader();
  if (headerWrapper) {
    if (document.body.classList.contains('template-product')) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 10) {
          headerWrapper.classList.add('rtc-header-scrolled');
        } else {
          headerWrapper.classList.remove('rtc-header-scrolled');
        }
      }, { passive: true });
    }
    // Homepage: white icons at top, dark on scroll
    if (document.body.classList.contains('template-index') && headerWrapper.hasAttribute('data-header-transparent')) {
      headerWrapper.classList.add('rtc-at-top');
      window.addEventListener('scroll', function() {
        if (window.scrollY > 10) {
          headerWrapper.classList.remove('rtc-at-top');
        } else {
          headerWrapper.classList.add('rtc-at-top');
        }
      }, { passive: true });
    }
  }

  // Mobile sticky buttons — wait for buttons block to be in the DOM
  if (document.body.classList.contains('template-product') && window.innerWidth < 750) {
    rtcWaitFor('.product__block--buttons', function(buttonsBlock) {

      var btnHeight = buttonsBlock.offsetHeight;

      // Create placeholder to prevent layout jump
      var placeholder = document.createElement('div');
      placeholder.className = 'rtc-sticky-placeholder';
      placeholder.style.height = btnHeight + 'px';
      buttonsBlock.parentNode.insertBefore(placeholder, buttonsBlock);

      // Start sticky
      buttonsBlock.classList.add('rtc-sticky-buttons');

      var isSticky = true;
      var ticking = false;

      function checkSticky() {
        if (!isSticky) return; // Once detached, stay detached

        var rect = placeholder.getBoundingClientRect();
        var stickyTop = window.innerHeight - btnHeight;

        if (rect.top <= stickyTop) {
          isSticky = false;
          buttonsBlock.classList.remove('rtc-sticky-buttons');
          placeholder.parentNode.removeChild(placeholder);
        }
        ticking = false;
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(checkSticky);
        }
      }, { passive: true });
    }, 10000);
  }
})(); } catch(e) { console.warn('RTC: header-scroll failed', e); }

/* RTC Kit Builder — sync primary card with product page variant selection + swap grid cards */
try { (function() {
  if (!document.body.classList.contains('template-product')) return;

  // Get product JSON data
  function getProductData() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        if (d && d.variants && d.options) { return d; }
      } catch(e) {}
    }
    return null;
  }

  // Find option index by name
  function findOptionIndex(productData, name) {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      if (productData.options[i].toLowerCase() === name) return i;
    }
    return -1;
  }

  // Get color from a variant
  function getVariantColor(variant, colorIdx) {
    if (variant.options && variant.options[colorIdx]) return variant.options[colorIdx];
    return variant['option' + (colorIdx + 1)] || null;
  }

  // Find first variant for a given color
  function firstVariantForColor(productData, colorIdx, color) {
    for (var i = 0; i < productData.variants.length; i++) {
      if (getVariantColor(productData.variants[i], colorIdx) === color) return productData.variants[i];
    }
    return null;
  }

  // Track current primary color so we can swap grid cards
  var _currentPrimaryColor = null;

  // Update a card's image, color label, variant ID, and size buttons for a given color
  function updateCardForColor(card, color, productData, colorIdx, sizeIdx) {
    var representative = firstVariantForColor(productData, colorIdx, color);
    if (!representative) return;

    // Update image
    var img = card.querySelector('.rtc-kit__card-image img');
    if (img && representative.featured_image && representative.featured_image.src) {
      img.src = representative.featured_image.src;
    }

    // Update color label
    var colorLabel = card.querySelector('.rtc-kit__card-color');
    if (colorLabel) colorLabel.textContent = color;

    // Update card variant ID
    card.setAttribute('data-variant-id', representative.id);

    // Update aria-label
    var title = card.querySelector('.rtc-kit__card-title');
    var titleText = title ? title.textContent.trim() : '';
    if (card.hasAttribute('data-kit-primary')) {
      card.setAttribute('aria-label', titleText + ' — your item, always included');
    } else {
      card.setAttribute('aria-label', titleText + ' — ' + color);
    }

    // Update size buttons for this color
    if (sizeIdx < 0) return;
    var sizeBtns = card.querySelectorAll('[data-kit-size-btn]');
    sizeBtns.forEach(function(btn) {
      var sizeLabel = btn.textContent.trim();
      var match = null;
      for (var v = 0; v < productData.variants.length; v++) {
        var pv = productData.variants[v];
        if (getVariantColor(pv, colorIdx) === color &&
            (pv.options ? pv.options[sizeIdx] : pv['option' + (sizeIdx + 1)]) === sizeLabel &&
            pv.available) {
          match = pv;
          break;
        }
      }
      if (match) {
        btn.disabled = false;
        btn.classList.remove('is-unavailable');
        btn.setAttribute('data-variant-id', match.id);
      } else {
        btn.disabled = true;
        btn.classList.add('is-unavailable');
        btn.classList.remove('is-active');
        btn.setAttribute('data-variant-id', '');
      }
    });
  }

  // Find the grid card (non-primary) that's currently showing a given color for this product
  function findGridCardByColor(color, productHandle) {
    var cards = document.querySelectorAll('[data-kit-card]:not([data-kit-primary])');
    for (var i = 0; i < cards.length; i++) {
      // Match by product handle on the sizes wrapper
      var sizesWrap = cards[i].querySelector('[data-kit-sizes]');
      if (!sizesWrap) continue;
      var handle = sizesWrap.getAttribute('data-product-handle');
      if (handle !== productHandle) continue;

      // Check color label
      var label = cards[i].querySelector('.rtc-kit__card-color');
      if (label && label.textContent.trim() === color) return cards[i];
    }
    return null;
  }

  // Main sync: update primary card AND swap the duplicate grid card
  function syncKitColors(newVariant, productData) {
    var primaryCard = document.querySelector('[data-kit-primary]');
    if (!primaryCard || !newVariant || !productData) return;

    var colorIdx = findOptionIndex(productData, 'color');
    if (colorIdx < 0) { colorIdx = findOptionIndex(productData, 'colour'); }
    if (colorIdx < 0) return;

    var sizeIdx = findOptionIndex(productData, 'size');
    var newColor = getVariantColor(newVariant, colorIdx);
    if (!newColor) return;

    // If color hasn't changed, nothing to do
    if (newColor === _currentPrimaryColor) return;

    var oldColor = _currentPrimaryColor;
    var productHandle = productData.handle;

    // Update primary card to new color
    updateCardForColor(primaryCard, newColor, productData, colorIdx, sizeIdx);

    // Find the grid card that's showing the NEW color (it will be a duplicate now)
    // and swap it to show the OLD color
    if (oldColor && productHandle) {
      var duplicateCard = findGridCardByColor(newColor, productHandle);
      if (duplicateCard) {
        updateCardForColor(duplicateCard, oldColor, productData, colorIdx, sizeIdx);
        // Deselect it if it was selected (since it's now a different color)
        duplicateCard.classList.remove('is-selected');
        var activeSizes = duplicateCard.querySelectorAll('[data-kit-size-btn].is-active');
        activeSizes.forEach(function(btn) { btn.classList.remove('is-active'); });
      }
    }

    _currentPrimaryColor = newColor;
  }

  // Initialize: determine starting primary color
  var productData = getProductData();
  if (productData) {
    var colorIdx = findOptionIndex(productData, 'color');
    if (colorIdx < 0) colorIdx = findOptionIndex(productData, 'colour');

    if (colorIdx >= 0) {
      // Check URL variant first
      var params = new URLSearchParams(window.location.search);
      var variantId = params.get('variant');
      var initVariant = null;

      if (variantId) {
        for (var i = 0; i < productData.variants.length; i++) {
          if (String(productData.variants[i].id) === variantId) {
            initVariant = productData.variants[i];
            break;
          }
        }
      }

      if (initVariant) {
        // Read whatever color the Liquid rendered on the primary card BEFORE we overwrite it
        var primaryCard = document.querySelector('[data-kit-primary]');
        var renderedLabel = primaryCard ? primaryCard.querySelector('.rtc-kit__card-color') : null;
        _currentPrimaryColor = renderedLabel ? renderedLabel.textContent.trim() : getVariantColor(initVariant, colorIdx);

        // Now sync to the correct variant
        syncKitColors(initVariant, productData);
      } else {
        // No URL variant — just read the current primary color from the rendered card
        var primaryCard = document.querySelector('[data-kit-primary]');
        var renderedLabel = primaryCard ? primaryCard.querySelector('.rtc-kit__card-color') : null;
        _currentPrimaryColor = renderedLabel ? renderedLabel.textContent.trim() : null;
      }
    }
  }

  // On variant change: sync primary card and swap grid card
  function onVariantChange() {
    var newParams = new URLSearchParams(window.location.search);
    var newVariantId = newParams.get('variant');
    if (!newVariantId) return;

    var pd = getProductData();
    if (!pd || !pd.variants) return;

    for (var i = 0; i < pd.variants.length; i++) {
      if (String(pd.variants[i].id) === newVariantId) {
        syncKitColors(pd.variants[i], pd);
        break;
      }
    }
  }

  // Listen for color swatch clicks
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.selector-wrapper--color label, .selector-wrapper--color input, .swatch__button, .radio__button, .product__siblings .sibling__link');
    if (swatch) {
      setTimeout(onVariantChange, 150);
      setTimeout(onVariantChange, 400);
    }
  });

  // Listen for popstate and variant input changes
  window.addEventListener('popstate', function() { setTimeout(onVariantChange, 100); });
  var variantInput = document.querySelector('select[name="id"], input[name="id"]');
  if (variantInput) {
    var inputObserver = new MutationObserver(function() { setTimeout(onVariantChange, 100); });
    inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    variantInput.addEventListener('change', function() { setTimeout(onVariantChange, 100); });
  }
})(); } catch(e) { console.warn('RTC: kit-primary-sync failed', e); }

/* RTC Kit Builder — scroll, select, add to cart */
try { (function() {
  // Cached DOM references for kit builder
  var _countEl, _totalEl, _discountTag, _addAllBtn, _miniCart, _miniCartWrap;
  function cacheKitEls() {
    _countEl = document.querySelector('[data-kit-count]');
    _totalEl = document.querySelector('[data-kit-total]');
    _discountTag = document.querySelector('[data-kit-discount-tag]');
    _addAllBtn = document.querySelector('[data-kit-add-all]');
    _miniCart = document.querySelector('[data-kit-mini-cart]');
    _miniCartWrap = document.querySelector('[data-kit-mini-cart-wrap]');
  }

  // Track whether the user has explicitly selected a size on the product page
  var _userSelectedSize = false;

  // Mirror Add to Cart disabled state to Build Your Kit button
  function syncKitBtnState() {
    var atcBtn = document.querySelector('[data-add-to-cart]');
    var kitBtn = document.querySelector('[data-rtc-kit-btn]');
    if (!atcBtn || !kitBtn) return;

    if (atcBtn.disabled) {
      kitBtn.disabled = true;
    } else {
      kitBtn.disabled = false;
    }

    // Only sync primary kit card after user has actually clicked a size
    if (!_userSelectedSize) return;

    // Sync product page size selection to primary kit card
    var primaryCard = document.querySelector('[data-kit-primary]');
    if (!primaryCard) return;

    var checkedRadio = document.querySelector('.selector-wrapper--size input[type="radio"]:checked');
    var selectedSize = checkedRadio ? checkedRadio.value : null;
    if (!selectedSize) {
      var sizeInput = document.querySelector('.selector-wrapper--size input[data-popout-input]');
      if (sizeInput && sizeInput.value) selectedSize = sizeInput.value;
    }

    if (selectedSize) {
      // Find matching size button on primary kit card and activate it
      var sizeBtns = primaryCard.querySelectorAll('[data-kit-size-btn]');
      var alreadyActive = false;
      sizeBtns.forEach(function(btn) {
        if (btn.textContent.trim() === selectedSize && btn.classList.contains('is-active')) {
          alreadyActive = true;
        }
      });
      if (!alreadyActive) {
        // Clear any previously active size on primary card first
        sizeBtns.forEach(function(btn) { btn.classList.remove('is-active'); });
        sizeBtns.forEach(function(btn) {
          if (btn.textContent.trim() === selectedSize && !btn.disabled) {
            btn.classList.add('is-active');
            primaryCard.classList.add('is-selected');
          }
        });
        updateKitSummary();
      }
    }
  }

  // Listen for user clicking a size on the product page size selector
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.selector-wrapper--size label, .selector-wrapper--size input, .radio__button');
    if (sizeBtn) {
      _userSelectedSize = true;
      // Small delay to let Shopify update the radio state
      setTimeout(syncKitBtnState, 50);
    }
  });

  // Watch the Add to Cart button for disabled changes
  rtcWaitFor('[data-add-to-cart]', function(atcBtn) {
    syncKitBtnState();
    var observer = new MutationObserver(function() { syncKitBtnState(); });
    observer.observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Also listen for form wrapper class changes (variant--soldout)
    var formWrapper = atcBtn.closest('.form__wrapper');
    if (formWrapper) {
      var formObserver = new MutationObserver(function() { syncKitBtnState(); });
      formObserver.observe(formWrapper, { attributes: true, attributeFilter: ['class'] });
    }

    // Initialize kit summary (primary product is always counted)
    updateKitSummary();
  }, 10000);

  // "Build Your Kit" button scrolls to kit section
  document.addEventListener('click', function(e) {
    var kitBtn = e.target.closest('[data-rtc-kit-btn]');
    if (!kitBtn || kitBtn.disabled) return;
    var kit = document.getElementById('rtc-kit-builder');
    if (!kit) return;
    var header = rtcThemeHeader();
    var headerHeight = header ? header.offsetHeight : 0;
    var kitTop = kit.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({ top: kitTop, behavior: 'smooth' });
  });

  // Kit filter pills
  document.addEventListener('click', function(e) {
    var filterBtn = e.target.closest('[data-kit-filter]');
    if (!filterBtn) return;
    var filterType = filterBtn.getAttribute('data-kit-filter');
    var allPills = document.querySelectorAll('[data-kit-filter]');
    allPills.forEach(function(f) { f.classList.remove('is-active'); f.setAttribute('aria-selected', 'false'); });
    filterBtn.classList.add('is-active');
    filterBtn.setAttribute('aria-selected', 'true');

    var cards = document.querySelectorAll('[data-kit-card]');
    cards.forEach(function(card) {
      // Primary card always visible
      if (card.hasAttribute('data-kit-primary')) return;
      if (filterType === 'all') {
        card.classList.remove('is-filtered-out');
      } else {
        var cardType = card.getAttribute('data-product-type') || '';
        if (cardType === filterType) {
          card.classList.remove('is-filtered-out');
        } else {
          card.classList.add('is-filtered-out');
        }
      }
    });
  });

  // Kit size selection
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('[data-kit-size-btn]');
    if (!sizeBtn || sizeBtn.disabled) return;
    e.stopPropagation();

    var card = sizeBtn.closest('[data-kit-card]');
    var sizesWrap = sizeBtn.closest('[data-kit-sizes]');
    var isPrimary = card && card.hasAttribute('data-kit-primary');

    // Toggle this size
    if (sizeBtn.classList.contains('is-active')) {
      sizeBtn.classList.remove('is-active');
      // Check if any sizes still active on this card
      var anyActive = sizesWrap.querySelector('[data-kit-size-btn].is-active');
      if (!anyActive && card) {
        card.classList.remove('is-selected');
        card.setAttribute('data-kit-qty', '1');
      }
      updateKitSummary();
      return;
    }

    // Allow multi-select on all cards
    sizeBtn.classList.add('is-active');

    // Update card state
    if (card) {
      if (!card.classList.contains('is-selected')) {
        card.classList.add('is-selected');
      }
      updateKitSummary();
    }
  });

  // Card deselection — clicking anywhere on card (not a size btn) deselects it
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-kit-size-btn]')) return;
    var card = e.target.closest('[data-kit-card]');
    if (!card) return;
    if (card.hasAttribute('data-kit-primary')) return;
    if (card.classList.contains('is-selected')) {
      card.classList.remove('is-selected');
      // Deselect active size
      var activeSize = card.querySelector('.rtc-kit__size.is-active');
      if (activeSize) activeSize.classList.remove('is-active');
      updateKitSummary();
    }
  });

  // Keyboard: Enter/Space on kit cards toggles selection, arrow keys navigate sizes
  document.addEventListener('keydown', function(e) {
    var target = e.target;

    // Enter/Space on a kit size button
    var sizeBtn = target.closest('[data-kit-size-btn]');
    if (sizeBtn && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      sizeBtn.click();
      return;
    }

    // Arrow keys within size picker — move focus between size buttons
    if (sizeBtn && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      e.preventDefault();
      var sizesWrap = sizeBtn.closest('[data-kit-sizes]');
      if (!sizesWrap) return;
      var btns = Array.prototype.slice.call(sizesWrap.querySelectorAll('[data-kit-size-btn]:not([disabled])'));
      var idx = btns.indexOf(sizeBtn);
      if (idx < 0) return;
      var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
      if (next >= 0 && next < btns.length) btns[next].focus();
      return;
    }

    // Arrow keys within filter pills — move focus between pill buttons
    var pill = target.closest('[data-kit-filter]');
    if (pill && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      e.preventDefault();
      var pillsWrap = pill.closest('[data-kit-filters]');
      if (!pillsWrap) return;
      var pills = Array.prototype.slice.call(pillsWrap.querySelectorAll('[data-kit-filter]'));
      var pIdx = pills.indexOf(pill);
      if (pIdx < 0) return;
      var pNext = e.key === 'ArrowRight' ? pIdx + 1 : pIdx - 1;
      if (pNext >= 0 && pNext < pills.length) pills[pNext].focus();
      return;
    }
  });

  function getKitDiscount(count) {
    if (count >= 4) return 35;
    if (count >= 3) return 25;
    if (count >= 2) return 15;
    return 0;
  }

  function getTotalItemCount() {
    // Always count from source of truth: selected cards + active sizes
    var selected = document.querySelectorAll('[data-kit-card].is-selected');
    var total = 0;
    selected.forEach(function(card) {
      var activeSizes = card.querySelectorAll('[data-kit-size-btn].is-active');
      total += activeSizes.length;
    });
    return total;
  }

  function updateKitSummary() {
    if (!_countEl) cacheKitEls();
    var allCards = document.querySelectorAll('[data-kit-card]');
    var selected = document.querySelectorAll('[data-kit-card].is-selected');
    var countEl = _countEl;
    var totalEl = _totalEl;
    var discountTag = _discountTag;
    var addAllBtn = _addAllBtn;
    var tiers = document.querySelectorAll('[data-kit-tier]');
    if (!countEl) return;

    // Count total items including quantities
    var count = getTotalItemCount();
    var discount = getKitDiscount(count);

    // Highlight active tier
    tiers.forEach(function(tier) {
      var tierNum = parseInt(tier.getAttribute('data-kit-tier'));
      if ((tierNum === 2 && count === 2) || (tierNum === 3 && count === 3) || (tierNum === 4 && count >= 4)) {
        tier.classList.add('is-active');
      } else {
        tier.classList.remove('is-active');
      }
    });

    // Update card sale prices:
    // - Selected cards show the current tier discount
    // - Unselected cards show what the price WOULD be if they added it (next tier)
    // ALL cards show the next-tier price preview (what adding one more item would cost)
    var nextDiscount = getKitDiscount(count + 1);
    allCards.forEach(function(card) {
      var saleEl = card.querySelector('[data-kit-card-sale]');
      var compareEl = card.querySelector('.rtc-kit__card-compare');
      var origPrice = parseInt(card.getAttribute('data-original-price') || 0);
      if (!saleEl) return;

      var salePrice = Math.round(origPrice * (100 - nextDiscount) / 100);

      if (nextDiscount > 0) {
        saleEl.textContent = '$' + (salePrice / 100).toFixed(2);
        saleEl.style.display = '';
        if (compareEl) {
          compareEl.style.textDecoration = 'line-through';
          compareEl.style.display = '';
        }
      } else {
        saleEl.textContent = '$' + (origPrice / 100).toFixed(2);
        if (compareEl) compareEl.style.display = 'none';
      }
    });

    countEl.textContent = count + ' item' + (count !== 1 ? 's' : '') + ' selected';

    if (count > 0) {
      var originalTotal = 0;
      selected.forEach(function(card) {
        var origPrice = parseInt(card.getAttribute('data-original-price') || 0);
        var activeSizes = card.querySelectorAll('[data-kit-size-btn].is-active');
        originalTotal += origPrice * activeSizes.length;
      });
      var discountTotal = Math.round(originalTotal * (100 - discount) / 100);
      var origFormatted = '$' + (originalTotal / 100).toFixed(2);
      var discFormatted = '$' + (discountTotal / 100).toFixed(2);
      totalEl.innerHTML = '<s>' + origFormatted + '</s> ' + discFormatted;
      if (discountTag) {
        if (nextDiscount > discount) {
          discountTag.textContent = 'Add 1 Item for ' + nextDiscount + '% Off';
        } else {
          discountTag.textContent = discount + '% Off';
        }
      }
      addAllBtn.disabled = false;
      addAllBtn.setAttribute('aria-disabled', 'false');
    } else {
      totalEl.innerHTML = '';
      if (discountTag) discountTag.textContent = 'Add 2 Items for 15% Off';
      addAllBtn.disabled = true;
      addAllBtn.setAttribute('aria-disabled', 'true');
    }

    // Build mini cart — preserve quantities from previous render
    var miniCart = _miniCart;
    if (miniCart) {
      var prevQtys = {};
      miniCart.querySelectorAll('.rtc-kit__mini-item').forEach(function(item) {
        var key = item.getAttribute('data-mini-variant') + '|' + item.getAttribute('data-mini-size-text');
        prevQtys[key] = parseInt(item.getAttribute('data-mini-qty') || '1');
      });
      miniCart.innerHTML = '';
      var miniIndex = 0;

      selected.forEach(function(card, cardIdx) {
        var img = card.querySelector('.rtc-kit__card-image img');
        var title = card.querySelector('.rtc-kit__card-title');
        var color = card.querySelector('.rtc-kit__card-color');
        var origPrice = parseInt(card.getAttribute('data-original-price') || 0);
        var isPrimary = card.hasAttribute('data-kit-primary');
        var imgSrc = img ? rtcEsc(img.getAttribute('src')) : '';
        var titleText = title ? rtcEsc(title.textContent.trim()) : '';
        var colorText = color ? rtcEsc(color.textContent.trim()) : '';

        // One mini-item per active size on every card
        var activeSizes = card.querySelectorAll('[data-kit-size-btn].is-active');
        activeSizes.forEach(function(sizeBtn) {
          var sizeText = rtcEsc(sizeBtn.textContent.trim());
          var variantId = sizeBtn.getAttribute('data-variant-id');
          var unitSale = discount > 0 ? Math.round(origPrice * (100 - discount) / 100) : origPrice;

          var metaParts = [];
          if (sizeText) metaParts.push(sizeText);
          if (colorText) metaParts.push(colorText);

          var qtyKey = variantId + '|' + sizeText;
          var restoredQty = prevQtys[qtyKey] || 1;

          var item = document.createElement('div');
          item.className = 'rtc-kit__mini-item';
          item.setAttribute('data-mini-card-index', cardIdx);
          item.setAttribute('data-mini-variant', variantId);
          item.setAttribute('data-mini-size-text', sizeText);
          item.setAttribute('data-mini-is-primary', isPrimary ? '1' : '0');
          item.setAttribute('data-mini-qty', restoredQty);
          var savings = origPrice - unitSale;
          var totalSavings = savings * restoredQty;
          var savingsTag = discount > 0 ? '<span class="rtc-kit__mini-savings">$' + (totalSavings / 100).toFixed(2) + ' OFF</span>' : '';

          item.innerHTML =
            (imgSrc ? '<img class="rtc-kit__mini-img" src="' + imgSrc + '" alt="">' : '') +
            '<div class="rtc-kit__mini-info">' +
              '<span class="rtc-kit__mini-title">' + titleText + '</span>' +
              (metaParts.length ? '<span class="rtc-kit__mini-meta">' + metaParts.join(' / ') + '</span>' : '') +
              '<div class="rtc-kit__mini-prices">' +
                (discount > 0 ? '<span class="rtc-kit__mini-compare">$' + (origPrice / 100).toFixed(2) + '</span>' : '') +
                '<span class="rtc-kit__mini-sale">$' + (unitSale / 100).toFixed(2) + '</span>' +
                savingsTag +
              '</div>' +
            '</div>' +
            '<div class="rtc-kit__mini-qty">' +
              '<button class="rtc-kit__qty-btn" data-kit-qty-minus>−</button>' +
              '<span class="rtc-kit__qty-val" data-kit-qty-val>' + restoredQty + '</span>' +
              '<button class="rtc-kit__qty-btn" data-kit-qty-plus>+</button>' +
            '</div>' +
            '<button class="rtc-kit__mini-remove" data-kit-mini-remove-size title="Remove">×</button>';

          miniCart.appendChild(item);
          miniIndex++;
        });
      });

      // Toggle overflow fade hint
      var wrap = _miniCartWrap;
      if (wrap) {
        requestAnimationFrame(function() {
          if (miniCart.scrollWidth > miniCart.clientWidth) {
            wrap.classList.add('has-overflow');
          } else {
            wrap.classList.remove('has-overflow');
          }
        });
      }
    }
  }

  // Hide overflow fade when scrolled to end
  document.addEventListener('scroll', function(e) {
    if (!e.target.classList || !e.target.classList.contains('rtc-kit__mini-cart')) return;
    var wrap = e.target.closest('[data-kit-mini-cart-wrap]');
    if (!wrap) return;
    var atEnd = e.target.scrollLeft + e.target.clientWidth >= e.target.scrollWidth - 5;
    if (atEnd) {
      wrap.classList.remove('has-overflow');
    } else {
      wrap.classList.add('has-overflow');
    }
  }, true);

  // Mini cart quantity buttons — per line item
  document.addEventListener('click', function(e) {
    var plus = e.target.closest('[data-kit-qty-plus]');
    var minus = e.target.closest('[data-kit-qty-minus]');
    if (!plus && !minus) return;

    var miniItem = (plus || minus).closest('.rtc-kit__mini-item');
    if (!miniItem) return;

    var qty = parseInt(miniItem.getAttribute('data-mini-qty') || '1');

    if (plus) {
      qty++;
    } else if (minus && qty > 1) {
      qty--;
    }

    miniItem.setAttribute('data-mini-qty', qty);

    // Update displayed value
    var valEl = miniItem.querySelector('[data-kit-qty-val]');
    if (valEl) valEl.textContent = qty;

    // Update savings tag for this line item
    var cardIdx = parseInt(miniItem.getAttribute('data-mini-card-index'));
    var selArr = document.querySelectorAll('[data-kit-card].is-selected');
    var card = selArr[cardIdx];
    if (card) {
      var origPrice = parseInt(card.getAttribute('data-original-price') || 0);
      var count = getTotalItemCount();
      var discount = getKitDiscount(count);
      var unitSale = discount > 0 ? Math.round(origPrice * (100 - discount) / 100) : origPrice;
      var savings = (origPrice - unitSale) * qty;
      var savingsEl = miniItem.querySelector('.rtc-kit__mini-savings');
      if (discount > 0 && savingsEl) {
        savingsEl.textContent = '$' + (savings / 100).toFixed(2) + ' OFF';
      }
    }

    // Recalculate totals (without full rebuild)
    var allMiniItems = document.querySelectorAll('.rtc-kit__mini-item');
    var totalCount = 0;
    var originalTotal = 0;
    allMiniItems.forEach(function(item) {
      var q = parseInt(item.getAttribute('data-mini-qty') || '1');
      totalCount += q;
      var ci = parseInt(item.getAttribute('data-mini-card-index'));
      var sa = document.querySelectorAll('[data-kit-card].is-selected');
      var c = sa[ci];
      if (c) originalTotal += parseInt(c.getAttribute('data-original-price') || 0) * q;
    });

    var disc = getKitDiscount(totalCount);
    var discountTotal = Math.round(originalTotal * (100 - disc) / 100);
    if (!_countEl) cacheKitEls();
    var countEl = _countEl;
    var totalEl = _totalEl;
    var discountTag = _discountTag;
    if (countEl) countEl.textContent = totalCount + ' item' + (totalCount !== 1 ? 's' : '') + ' selected';
    if (totalEl) totalEl.innerHTML = '<s>$' + (originalTotal / 100).toFixed(2) + '</s> $' + (discountTotal / 100).toFixed(2);

    // Update discount tag CTA
    if (discountTag) {
      var nextDisc = getKitDiscount(totalCount + 1);
      if (totalCount === 0) {
        discountTag.textContent = 'Add 2 Items for 15% Off';
      } else if (nextDisc > disc) {
        discountTag.textContent = 'Add 1 Item for ' + nextDisc + '% Off';
      } else {
        discountTag.textContent = disc + '% Off';
      }
    }

    // Update tier highlights
    var tiers = document.querySelectorAll('[data-kit-tier]');
    tiers.forEach(function(tier) {
      var tierNum = parseInt(tier.getAttribute('data-kit-tier'));
      if ((tierNum === 2 && totalCount === 2) || (tierNum === 3 && totalCount === 3) || (tierNum === 4 && totalCount >= 4)) {
        tier.classList.add('is-active');
      } else {
        tier.classList.remove('is-active');
      }
    });
  });

  // Mini cart remove button — unified for all cards
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-kit-mini-remove-size]');
    if (!removeBtn) return;

    var miniItem = removeBtn.closest('.rtc-kit__mini-item');
    if (!miniItem) return;

    var cardIdx = parseInt(miniItem.getAttribute('data-mini-card-index'));
    var sizeText = miniItem.getAttribute('data-mini-size-text');
    var selected = document.querySelectorAll('[data-kit-card].is-selected');
    var card = selected[cardIdx];
    if (!card) return;

    // Deactivate the matching size button
    var sizeBtns = card.querySelectorAll('[data-kit-size-btn].is-active');
    sizeBtns.forEach(function(btn) {
      if (btn.textContent.trim() === sizeText) btn.classList.remove('is-active');
    });

    // If no sizes left active, deselect the card
    var anyActive = card.querySelector('[data-kit-size-btn].is-active');
    if (!anyActive) {
      card.classList.remove('is-selected');
    }
    updateKitSummary();
  });

  // Add all selected to cart
  document.addEventListener('click', function(e) {
    var addAllBtn = e.target.closest('[data-kit-add-all]');
    if (!addAllBtn || addAllBtn.disabled) return;

    var selected = document.querySelectorAll('[data-kit-card].is-selected');
    if (selected.length === 0) return;

    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Adding...';

    var items = [];

    // Add all selected items — use quantity from mini cart line items
    var miniItems = document.querySelectorAll('.rtc-kit__mini-item');
    miniItems.forEach(function(item) {
      var variantId = parseInt(item.getAttribute('data-mini-variant'));
      var qty = parseInt(item.getAttribute('data-mini-qty') || '1');
      if (variantId && qty > 0) {
        items.push({ id: variantId, quantity: qty });
      }
    });

    var totalQty = 0;
    items.forEach(function(i) { totalQty += i.quantity; });
    var _t = '';
    if (totalQty >= 4) _t = 'RTC-BK9L1W5-35';
    else if (totalQty >= 3) _t = 'RTC-BK4P3Q8-25';
    else if (totalQty >= 2) _t = 'RTC-BK7X9M2-15';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      addAllBtn.textContent = 'Added to Cart!';
      if (_t) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { kit_discount: _t } })
        });
      }
    })
    .then(function() {
      // Redirect to cart page after brief confirmation
      setTimeout(function() {
        var url = '/cart';
        window.location.href = url;
      }, 800);
    })
    .catch(function() {
      addAllBtn.textContent = 'Add Kit to Cart';
      addAllBtn.disabled = false;
    });
  });
})(); } catch(e) { console.warn('RTC: kit-builder failed', e); }

/* RTC Bundle Upsell — Add to cart */
try { (function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
      // Update cart count
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function(el) { el.textContent = cart.item_count; });
        var bubble = document.querySelector('.cart__bubble');
        if (bubble) bubble.textContent = cart.item_count;
      });
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to cart';
      }, 2000);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Add to cart';
    });
  });
})(); } catch(e) { console.warn('RTC: bundle-upsell failed', e); }


try { (function() {
  var DASHBOARD_URL = 'https://affiliate-dashboard-wine.vercel.app';
  var COOKIE_NAME = 'rtc_ref';
  var COOKIE_DAYS = 30;
  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref');
  if (ref) {
    var expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_DAYS);
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(ref) + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
    var img = new Image();
    img.src = DASHBOARD_URL + '/api/track-click?ref=' + encodeURIComponent(ref) + '&url=' + encodeURIComponent(window.location.href);
  }
  function getRefCookie() {
    var match = document.cookie.match(new RegExp('(^| )' + COOKIE_NAME + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
  var savedRef = getRefCookie();
  if (savedRef) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referral_code: savedRef } })
    }).catch(function() {});

    // Auto-fill athlete code on cart page if empty
    var athleteInput = document.getElementById('rtc-athlete-code-input');
    if (athleteInput && !athleteInput.value) {
      athleteInput.value = savedRef.toUpperCase();
    }
  }
})(); } catch(e) { console.warn('RTC: referral-tracking failed', e); }


/**
 * RTC Sticky Product Bar — Mobile
 * Mirrors variant selectors from Broadcast's popout-select custom elements
 * into a sticky bottom bar with native <select> proxies.
 *
 * Broadcast DOM structure:
 *   .selector-wrapper > fieldset > legend (.radio__legend__option-name)
 *                                > popout-select > button[data-popout-toggle]
 *                                                > ul[data-popout-list] > li > a[data-popout-option][data-value]
 *                                                > input[type=hidden][data-popout-input][data-single-option-selector]
 *
 * Some options use radio fieldsets instead:
 *   .selector-wrapper > fieldset.radio__fieldset > legend
 *                                                > .radio__button > input[type=radio][value] + label
 */
try { (function() {
  if (window.innerWidth > 749) return;
  if (!document.body.classList.contains('template-product')) return;

  function initBar() {
    var bar = document.querySelector('[data-rtc-product-bar]');
    if (!bar) return;

    var selectorsWrap = bar.querySelector('[data-rtc-bar-selectors]');
    var cartBtn = bar.querySelector('[data-rtc-bar-cart]');
    var cartText = bar.querySelector('[data-rtc-bar-cart-text]');
    var priceEl = bar.querySelector('[data-rtc-bar-price]');

    // Clear any previous attempts
    selectorsWrap.innerHTML = '';

    // Find the original product form
    var productForm = document.querySelector('product-form form[data-product-form]');
    if (!productForm) productForm = document.querySelector('form[data-product-form]');

    // Find ALL selector wrappers (each holds one option like Color or Size)
    var selectorWrappers = document.querySelectorAll('.product__content .selector-wrapper');
    var builtCount = 0;

    selectorWrappers.forEach(function(wrapper) {
      // Get the option name (Color, Size, etc.)
      var legendLabel = wrapper.querySelector('.radio__legend__option-name');
      var optionName = legendLabel ? legendLabel.textContent.trim() : '';

      // --- Method 1: popout-select with hidden input ---
      var popoutInput = wrapper.querySelector('input[data-popout-input]');
      var popoutOptions = wrapper.querySelectorAll('a[data-popout-option]');

      if (popoutInput && popoutOptions.length > 0) {
        var wrap = document.createElement('div');
        wrap.className = 'rtc-product-bar__select-wrap';

        var proxy = document.createElement('select');
        proxy.className = 'rtc-product-bar__select';

        var currentVal = popoutInput.value;

        popoutOptions.forEach(function(optLink) {
          var val = optLink.getAttribute('data-value');
          if (!val) return;
          var opt = document.createElement('option');
          opt.value = val;
          opt.textContent = (optionName ? optionName + ': ' : '') + val;
          if (val === currentVal) opt.selected = true;
          proxy.appendChild(opt);
        });

        // On proxy change → click the matching popout option in the original
        proxy.addEventListener('change', function() {
          var target = wrapper.querySelector('a[data-popout-option][data-value="' + proxy.value + '"]');
          if (target) {
            target.click();
          } else {
            // Fallback: set the hidden input directly and dispatch change
            popoutInput.value = proxy.value;
            popoutInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Observe hidden input for changes from the original UI
        var inputObserver = new MutationObserver(function() {
          if (popoutInput.value !== proxy.value) {
            proxy.value = popoutInput.value;
          }
        });
        inputObserver.observe(popoutInput, { attributes: true, attributeFilter: ['value'] });

        // Intercept JS value changes on the hidden input (no polling needed)
        var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        Object.defineProperty(popoutInput, 'value', {
          get: function() { return desc.get.call(this); },
          set: function(v) { desc.set.call(this, v); proxy.value = v; }
        });

        wrap.appendChild(proxy);
        selectorsWrap.appendChild(wrap);
        builtCount++;
        return;
      }

      // --- Method 2: radio button fieldset ---
      var radios = wrapper.querySelectorAll('input[type="radio"]');
      if (radios.length > 0) {
        var wrap = document.createElement('div');
        wrap.className = 'rtc-product-bar__select-wrap';

        var proxy = document.createElement('select');
        proxy.className = 'rtc-product-bar__select';

        radios.forEach(function(radio) {
          var val = radio.value;
          var opt = document.createElement('option');
          opt.value = val;
          opt.textContent = (optionName ? optionName + ': ' : '') + val;
          if (radio.checked) opt.selected = true;
          proxy.appendChild(opt);
        });

        proxy.addEventListener('change', function() {
          radios.forEach(function(radio) {
            if (radio.value === proxy.value) {
              radio.click();
            }
          });
        });

        // Observe radio changes
        radios.forEach(function(radio) {
          radio.addEventListener('change', function() {
            if (radio.checked) proxy.value = radio.value;
          });
        });

        wrap.appendChild(proxy);
        selectorsWrap.appendChild(wrap);
        builtCount++;
        return;
      }
    });

    console.log('[RTC Bar] Built ' + builtCount + ' proxy selectors from ' + selectorWrappers.length + ' wrappers');

    // Cart button — submit the original form
    cartBtn.addEventListener('click', function() {
      if (cartBtn.disabled) return;
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.click();
      } else if (productForm) {
        productForm.dispatchEvent(new Event('submit', { bubbles: true }));
      }
    });

    // Watch for variant changes to update price and availability
    function updateBar() {
      var addBtn = document.querySelector('[data-add-to-cart]');
      var addText = document.querySelector('[data-add-to-cart-text]');
      var priceSource = document.querySelector('.product__price .price');

      if (addBtn) {
        cartBtn.disabled = addBtn.disabled;
        cartBtn.setAttribute('aria-disabled', String(addBtn.disabled));
      }
      if (addText) {
        cartText.textContent = addText.textContent.trim();
      }
      if (priceSource) {
        priceEl.textContent = priceSource.textContent.trim();
      }
    }

    // Observe price/button changes
    var formWrapper = document.querySelector('[data-form-wrapper]');
    if (formWrapper) {
      var formObserver = new MutationObserver(updateBar);
      formObserver.observe(formWrapper, { childList: true, subtree: true, attributes: true, characterData: true });
    }

    // Initial state
    updateBar();
    cartBtn.disabled = false;

    // Check actual availability
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (addBtn && addBtn.disabled) {
      cartBtn.disabled = true;
      cartBtn.setAttribute('aria-disabled', 'true');
    }

    // Focus management: Escape inside the bar returns focus to the main ATC button
    bar.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var mainAtc = document.querySelector('[data-add-to-cart]');
        if (mainAtc) mainAtc.focus();
      }
    });
  }

  // Wait for Broadcast's product component — look for selector wrappers
  rtcWaitFor('.product__content .selector-wrapper', function() {
    initBar();
  }, 10000);
})(); } catch(e) { console.warn('RTC: product-bar failed', e); }

/* --- Product Image Pagination Dots --- */
try { (function() {
  if (window.innerWidth > 749) return;
  if (!document.body.classList.contains('template-product')) return;

  function initDots() {
    var slidesContainer = document.querySelector('.product__images .product__slides');
    if (!slidesContainer) return;

    var slides = slidesContainer.querySelectorAll('.product__slide:not(.product__photo--blank)');
    if (slides.length < 2) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'rtc-slide-dots';

    var dots = [];
    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('div');
      dot.className = 'rtc-slide-dots__dot';
      if (i === 0) dot.classList.add('is-active');
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }

    var breadcrumbs = document.querySelector('.product__content .product__breadcrumbs');
    if (breadcrumbs) {
      breadcrumbs.style.position = 'relative';
      breadcrumbs.appendChild(dotsWrap);
    } else {
      var productHead = document.querySelector('.product__content .product__head');
      if (productHead) {
        productHead.style.position = 'relative';
        productHead.insertBefore(dotsWrap, productHead.firstChild);
      }
    }

    // Track scroll position to update active dot
    var scrollTimeout;
    slidesContainer.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var scrollLeft = slidesContainer.scrollLeft;
        var slideWidth = slidesContainer.offsetWidth;
        var activeIndex = Math.round(scrollLeft / slideWidth);
        dots.forEach(function(d, idx) {
          d.classList.toggle('is-active', idx === activeIndex);
        });
      }, 50);
    });
  }

  rtcWaitFor('.product__images .product__slides', initDots, 10000);
})(); } catch(e) { console.warn('RTC: image-dots failed', e); }


try { (function() {
  function fixChevrons() {
    if (window.innerWidth < 750) return;
    var prev = document.querySelector('.product__slides .slider__button--prev');
    var next = document.querySelector('.product__slides .slider__button--next');
    if (prev) {
      var parent = prev.closest('.slider__arrows') || prev.parentElement;
      var parentLeft = parent.getBoundingClientRect().left;
      var desiredLeft = 20;
      var adjustedLeft = desiredLeft - parentLeft;
      prev.style.cssText = 'transform: translateY(-50%) !important; left: ' + adjustedLeft + 'px !important; opacity: 1 !important; visibility: visible !important; transition: none !important;';
    }
    if (next) {
      next.style.cssText = 'transform: translateY(-50%) !important; opacity: 1 !important; visibility: visible !important; transition: none !important;';
    }
  }

  function movePriceToTitle() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.innerWidth < 750) return;
    var titleWrapper = document.querySelector('.product__title__wrapper');
    var priceWrap = document.querySelector('.product__price__wrap');
    if (!titleWrapper || !priceWrap) return;
    var priceBlock = priceWrap.closest('.product__block');
    titleWrapper.appendChild(priceWrap);
    if (priceBlock) priceBlock.classList.add('rtc-price-moved');
  }

  function moveInstallmentsToTitle() {
    if (!document.body.classList.contains('template-product')) return;
    if (window.innerWidth < 750) return;
    var productHead = document.querySelector('.product__head');
    if (!productHead) return;

    function doMove() {
      var shopPayTerms = document.querySelector('.shop-pay-terms');
      if (!shopPayTerms) return false;
      productHead.parentNode.insertBefore(shopPayTerms, productHead.nextSibling);
      return true;
    }

    if (!doMove()) {
      // Shop Pay terms loads async — watch for it
      var observer = new MutationObserver(function(mutations, obs) {
        if (doMove()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Stop watching after 10 seconds
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  }

  function initSizeRequired() {
    if (!document.body.classList.contains('template-product')) return;
    movePriceToTitle();
    moveInstallmentsToTitle();

    var sizeWrapper = document.querySelector('.selector-wrapper--size');
    if (!sizeWrapper) return;

    var addBtn = document.querySelector('[data-add-to-cart]');
    var addText = document.querySelector('[data-add-to-cart-text]');
    if (!addBtn || !addText) return;

    // Uncheck the default selected size
    var checkedSize = sizeWrapper.querySelector('input[type="radio"]:checked');
    if (checkedSize) {
      checkedSize.checked = false;
      // Remove active label styling
      var activeLabel = checkedSize.parentElement;
      if (activeLabel) activeLabel.classList.remove('is-active');
    }

    // Disable add to cart and change text
    var sizeSelected = false;
    addBtn.disabled = true;
    addText.textContent = 'Select a Size';

    // Also disable the Shop Pay button
    var spbBtn = document.querySelector('.shopify-payment-button__button');
    if (spbBtn) spbBtn.style.pointerEvents = 'none';

    function lockButton() {
      addBtn.disabled = true;
      addText.textContent = 'Select a Size';
      var spb = document.querySelector('.shopify-payment-button__button');
      if (spb) spb.style.pointerEvents = 'none';
    }

    function unlockButton() {
      addBtn.disabled = false;
      addText.textContent = 'Add to Cart';
      var spb = document.querySelector('.shopify-payment-button__button');
      if (spb) spb.style.pointerEvents = '';
    }

    // Listen for size selection
    sizeWrapper.addEventListener('change', function(e) {
      if (e.target.type === 'radio') {
        sizeSelected = true;
        setTimeout(function() { unlockButton(); }, 100);
      }
    });

    // Listen for color changes — reset size requirement
    var colorWrappers = document.querySelectorAll('.selector-wrapper:not(.selector-wrapper--size)');
    colorWrappers.forEach(function(wrapper) {
      wrapper.addEventListener('change', function() {
        // Uncheck the size selection
        var sizeRadios = sizeWrapper.querySelectorAll('input[type="radio"]');
        sizeRadios.forEach(function(r) { r.checked = false; });
        sizeSelected = false;
        setTimeout(function() { lockButton(); }, 150);
      });
    });

    // Watch for the theme re-enabling the button behind our back
    var observer = new MutationObserver(function() {
      if (!sizeSelected && !addBtn.disabled) {
        lockButton();
      }
    });
    observer.observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
    observer.observe(addText, { childList: true, characterData: true, subtree: true });

    // Intercept add-to-cart clicks when no size selected
    addBtn.closest('form').addEventListener('submit', function(e) {
      if (!sizeSelected) {
        e.preventDefault();
        e.stopPropagation();
        addText.textContent = 'Please Select a Size';
        addBtn.classList.add('rtc-shake');
        setTimeout(function() {
          addBtn.classList.remove('rtc-shake');
          addText.textContent = 'Select a Size';
        }, 1500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeRequired();
    });
  } else {
    initSizeRequired();
  }
  rtcWaitFor('.product__slides .slider__button--next', fixChevrons, 10000);
})(); } catch(e) { console.warn('RTC: size-required failed', e); }


/**
 * RTC Collection Header — sticky through content, then slides up with page
 * Same pattern as working product page header script above
 */
try { (function() {
  if (!document.body.classList.contains('template-collection')) return;

  function init() {
    var header = rtcHeader();
    var grid = document.querySelector('.collection-products');
    if (!header || !grid) return;

    var th = header.querySelector('.theme__header');
    if (!th) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function() {
        var gridTop = grid.getBoundingClientRect().top;
        var headerHeight = th.offsetHeight;

        if (gridTop <= headerHeight) {
          var offset = gridTop - headerHeight;
          header.style.setProperty('--rtc-header-offset', offset + 'px');
          header.classList.add('rtc-header-released');
        } else {
          header.style.setProperty('--rtc-header-offset', '0px');
          if (header.classList.contains('rtc-header-released')) {
            header.classList.remove('rtc-header-released');
          }
        }

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); } catch(e) { console.warn('RTC: collection-header failed', e); }


/* RTC: Move product card price below color variant */
try { (function() {
  function moveCardPrices() {
    document.querySelectorAll('.product-item__title-row').forEach(function(row) {
      if (row.dataset.rtcPriceMoved) return;
      var price = row.querySelector('.product-item__price');
      var color = row.parentElement.querySelector('.product-item__color');
      if (price && color) {
        var clone = price.cloneNode(true);
        clone.style.display = 'block';
        clone.style.textAlign = 'center';
        clone.style.marginTop = '2px';
        clone.classList.add('rtc-card-price');
        color.after(clone);
        price.style.display = 'none';
        row.dataset.rtcPriceMoved = 'true';
      }
    });
  }
  rtcWaitFor('.product-item__title-row', moveCardPrices, 10000);
})(); } catch(e) { console.warn('RTC: card-price failed', e); }


try { (function() {
  'use strict';
  if (window.matchMedia('(max-width: 749px)').matches) return;

  function closePicker(picker) {
    if (!picker) return;
    picker.classList.remove('is-open');
    var h = picker.closest('.quick-add__holder');
    if (h) h.classList.remove('rtc-sizes-open');
  }

  function closeAllPickers(except) {
    document.querySelectorAll('.rtc-size-picker.is-open').forEach(function(p) {
      if (p !== except) closePicker(p);
    });
  }

  function openPicker(holder) {
    var picker = holder ? holder.querySelector('[data-rtc-size-picker]') : null;
    if (!picker) return;
    closeAllPickers(picker);
    picker.style.display = 'block';
    picker.offsetHeight;
    picker.classList.add('is-open');
    holder.classList.add('rtc-sizes-open');
  }

  function init() {
    // Hover: open size picker when hovering the "+" button
    document.addEventListener('mouseenter', function(e) {
      var toggleBtn = e.target.closest('[data-rtc-size-toggle]');
      if (toggleBtn) {
        var holder = toggleBtn.closest('.quick-add__holder');
        openPicker(holder);
      }
    }, true);

    // Mouse leave the entire product image area — close picker
    document.addEventListener('mouseleave', function(e) {
      var imageWrap = e.target.closest('.product-item__image');
      if (imageWrap) {
        var holder = imageWrap.querySelector('.quick-add__holder');
        var picker = holder ? holder.querySelector('[data-rtc-size-picker]') : null;
        if (picker && picker.classList.contains('is-open')) {
          closePicker(picker);
        }
      }
    }, true);

    // Click: prevent "+" from opening the modal
    document.addEventListener('click', function(e) {
      var toggleBtn = e.target.closest('[data-rtc-size-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var holder = toggleBtn.closest('.quick-add__holder');
        openPicker(holder);
        return;
      }

      // Handle size button click — add to cart
      var sizeBtn = e.target.closest('[data-rtc-size-btn]');
      if (sizeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeBtn.disabled || sizeBtn.classList.contains('is-adding')) return;

        var variantId = sizeBtn.getAttribute('data-variant-id');
        sizeBtn.classList.add('is-adding');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          sizeBtn.classList.remove('is-adding');

          // Show "Added" confirmation
          var picker = sizeBtn.closest('[data-rtc-size-picker]');
          var added = picker ? picker.querySelector('[data-rtc-size-added]') : null;
          if (added) {
            added.classList.add('is-visible');
            setTimeout(function() {
              added.classList.remove('is-visible');
            }, 1500);
          }

          // Update cart count
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function(el) {
                el.textContent = cart.item_count;
              });
              document.querySelectorAll('.header__cart__count').forEach(function(b) {
                b.textContent = cart.item_count;
                b.setAttribute('data-cart-count', cart.item_count);
              });
            });

          // Close picker after short delay
          setTimeout(function() {
            closePicker(picker);
          }, 1800);
        })
        .catch(function(err) {
          sizeBtn.classList.remove('is-adding');
          console.error('RTC size picker add error:', err);
        });
        return;
      }

      // Click outside — close any open pickers
      if (!e.target.closest('[data-rtc-size-picker]') && !e.target.closest('[data-rtc-size-toggle]')) {
        closeAllPickers();
      }
    }, true);

    // Keyboard: Escape closes picker, arrows navigate size buttons
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllPickers();
        return;
      }
      var sizeBtn = e.target.closest('[data-rtc-size-btn]');
      if (sizeBtn && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        var picker = sizeBtn.closest('[data-rtc-size-picker]');
        if (!picker) return;
        var btns = Array.prototype.slice.call(picker.querySelectorAll('[data-rtc-size-btn]:not([disabled])'));
        var idx = btns.indexOf(sizeBtn);
        if (idx < 0) return;
        var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
        if (next >= 0 && next < btns.length) btns[next].focus();
      }
      if (sizeBtn && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        sizeBtn.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); } catch(e) { console.warn('RTC: size-picker failed', e); }

// =============================================================
// Checkout button — adds current variant to cart then redirects
// =============================================================
try { (function() {
  function init() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-rtc-checkout-btn]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;
      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!variantInput || !variantInput.value) return;
      btn.disabled = true;
      var txt = btn.querySelector('.btn__text');
      var orig = txt ? txt.textContent : '';
      if (txt) txt.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 })
      }).then(function(r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function() {
        if (txt) txt.textContent = orig;
        btn.disabled = false;
        alert('Could not add to cart. Please try again.');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); } catch(e) { console.warn('RTC: checkout-btn failed', e); }

/* ─────────────────────────────────────────────────────────────
   RTC HOVER PEEK behavior (Aug 2026)
   - Color chip click swaps the card's main product image
     (does NOT navigate to the PDP).
   - Size button with data-rtc-open-drawer opens the cart drawer
     after the existing data-rtc-size-btn handler adds to cart.
   ───────────────────────────────────────────────────────────── */
(function(){
  document.addEventListener('click', function(e) {
    // ── Color chip: swap main image ──
    var colorBtn = e.target.closest('[data-rtc-peek-color]');
    if (colorBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = colorBtn.closest('.product-item');
      var peek = colorBtn.closest('[data-rtc-peek]');
      if (!card || !peek) return;

      var newSrc = colorBtn.getAttribute('data-image');
      var color  = colorBtn.getAttribute('data-color');

      // Swap the main product image
      if (newSrc) {
        var img = card.querySelector('.product-item__bg img, .product-item__image img');
        if (img) {
          img.src = newSrc;
          img.removeAttribute('srcset');
        }
      }

      // Update active chip state
      peek.querySelectorAll('[data-rtc-peek-color]').forEach(function(btn){
        btn.classList.toggle('is-active', btn === colorBtn);
      });

      // Filter size buttons: only show sizes for the selected color
      peek.querySelectorAll('[data-rtc-peek-size]').forEach(function(sBtn){
        var sc = sBtn.getAttribute('data-color') || '';
        sBtn.classList.toggle('is-hidden', sc !== '' && sc !== color);
      });

      // Update the colorway label below the title to match the selected color
      var colorEl = card.querySelector('.product-item__color');
      if (colorEl && color) colorEl.textContent = color;

      // Blur so :focus-within doesn't keep the peek open after mouseleave
      try { colorBtn.blur(); } catch (_) {}
      return;
    }

    // ── Size button with drawer flag: open cart drawer after add ──
    // The existing data-rtc-size-btn handler POSTs to /cart/add.js on click.
    // We piggyback: if data-rtc-open-drawer is set, dispatch drawer:show once
    // the count updates. We watch for the theme:cart:change event dispatched
    // by the existing handler, then open the drawer.
    var sizeBtn = e.target.closest('[data-rtc-peek-size][data-rtc-open-drawer]');
    if (sizeBtn && !sizeBtn.disabled) {
      // Mark to open drawer on the next cart change
      window.__rtcOpenDrawerOnNextCartChange = true;
    }
  }, true);

  // When the existing size-btn handler fires theme:cart:change after a
  // successful add, open the drawer (once).
  document.addEventListener('theme:cart:change', function(){
    if (window.__rtcOpenDrawerOnNextCartChange) {
      window.__rtcOpenDrawerOnNextCartChange = false;
      // Refresh cart contents then show drawer
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
    }
  });
})();

/* ASRV-style layout (Aug 23): peek sits INSIDE the info block, between the
   color line and the price. Price is moved OUT of the product-link anchor
   so we can order badge/title/color → peek → price as siblings in a flex
   column. Price stays anchored to the bottom via margin-top:auto (see CSS).
   Non-hover: peek collapsed to 0. Hover: peek expands, top meta appears to
   shift up, price stays in the same relative bottom position. */
(function(){
  function restructure(root) {
    (root || document).querySelectorAll('.product-item').forEach(function(card) {
      if (card.dataset.rtcAsrvStacked === '1') return;
      var info = card.querySelector('.product-item__info');
      if (!info) return;
      var anchor = info.querySelector('a.product-link');
      var priceInAnchor = anchor && anchor.querySelector('.product-item__price--rtc-below');
      var peek = card.querySelector('.rtc-peek');
      // Ensure peek is a direct child of info block (not inside image)
      if (peek && peek.parentElement !== info) {
        info.appendChild(peek);
      }
      // Move price out of anchor so it can be the last flex child in info
      if (priceInAnchor) {
        info.appendChild(priceInAnchor);
      }
      card.dataset.rtcAsrvStacked = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ restructure(); });
  } else {
    restructure();
  }
  document.addEventListener('theme:collection:updated', function(){ restructure(); });
  document.addEventListener('shopify:section:load', function(e){ restructure(e.target); });
})();

/* RTC — Hide "THE (NNN)" and "THE (RTC)" prefix from product titles
   on the storefront (Aug 2026 Option A test). Non-destructive: real
   title in Shopify stays, badge extraction still reads (NNN) server-side. */
(function(){
  var PREFIX_RE = /^THE\s*\([^)]+\)\s+/i;
  var SELECTORS = [
    '.product-item__title',
    '.product-title',
    '.product-single__title',
    '.product__title',
    '[data-product-title]',
    '.cart__item__title',
    '.cart-item__title',
    '.cart__line-item__title',
    '.cart-line-item__title',
    '.line-item__title',
    '.search-item__title',
    '.search-product-item__title',
    '.rtc-line-item__title'
  ].join(',');
  function clean(el) {
    if (!el || el.dataset.rtcTitleCleaned === '1') return;
    var t = (el.textContent || '').trim();
    if (!t) return;
    var cleaned = t.replace(PREFIX_RE, '');
    if (cleaned !== t && cleaned.length > 0) {
      el.textContent = cleaned;
    }
    el.dataset.rtcTitleCleaned = '1';
  }
  function scan(root) {
    (root || document).querySelectorAll(SELECTORS).forEach(clean);
  }
  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function(){ scheduled = false; scan(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(); });
  } else {
    scan();
  }
  ['theme:cart:change','theme:cart:refresh','theme:cart-drawer:show','shopify:section:load'].forEach(function(ev){
    document.addEventListener(ev, scheduleScan);
  });
  if (window.MutationObserver) {
    var mo = new MutationObserver(function(muts){
      var added = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length > 0) { added = true; break; }
      }
      if (added) scheduleScan();
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* ─────────────────────────────────────────────────────────────
   RTC — Area code → state prefix on badges (Aug 2026)
   Renders "STATE-CODE" (e.g. AL-205) instead of raw area code.
   ───────────────────────────────────────────────────────────── */
(function(){
  var AC = {
    '201':'NJ','202':'DC','203':'CT','204':'CAN','205':'AL','206':'WA','207':'ME','208':'ID','209':'CA',
    '210':'TX','212':'NY','213':'CA','214':'TX','215':'PA','216':'OH','217':'IL','218':'MN','219':'IN',
    '220':'OH','223':'PA','224':'IL','225':'LA','226':'CAN','227':'MD','228':'MS','229':'GA','231':'MI',
    '234':'OH','235':'MO','236':'CAN','239':'FL','240':'MD','242':'BHS','246':'BRB','248':'MI','249':'CAN',
    '250':'CAN','251':'AL','252':'NC','253':'WA','254':'TX','256':'AL','257':'CAN','260':'IN','262':'WI',
    '263':'CAN','264':'AI','267':'PA','268':'ATG','269':'MI','270':'KY','272':'PA','274':'WI','276':'VA',
    '279':'CA','281':'TX','283':'OH','289':'CAN','301':'MD','302':'DE','303':'CO','304':'WV','305':'FL',
    '306':'CAN','307':'WY','308':'NE','309':'IL','310':'CA','312':'IL','313':'MI','314':'MO','315':'NY',
    '316':'KS','317':'IN','318':'LA','319':'IA','320':'MN','321':'FL','323':'CA','324':'FL','325':'TX',
    '326':'OH','327':'AR','329':'NY','330':'OH','331':'IL','332':'NY','334':'AL','336':'NC','337':'LA',
    '339':'MA','340':'VI','341':'CA','343':'CAN','346':'TX','347':'NY','350':'CA','351':'MA','352':'FL',
    '353':'WI','354':'CAN','357':'CA','360':'WA','361':'TX','363':'NY','364':'KY','365':'CAN','367':'CAN',
    '368':'CAN','369':'CA','380':'OH','382':'CAN','385':'UT','386':'FL','401':'RI','402':'NE','403':'CAN',
    '404':'GA','405':'OK','406':'MT','407':'FL','408':'CA','409':'TX','410':'MD','412':'PA','413':'MA',
    '414':'WI','415':'CA','416':'CAN','417':'MO','418':'CAN','419':'OH','423':'TN','424':'CA','425':'WA',
    '428':'CAN','430':'TX','431':'CAN','432':'TX','434':'VA','435':'UT','436':'OH','437':'CAN','438':'CAN',
    '440':'OH','441':'BMU','442':'CA','443':'MD','445':'PA','447':'IL','448':'FL','450':'CAN','457':'LA',
    '458':'OR','463':'IN','464':'IL','468':'CAN','469':'TX','470':'GA','472':'NC','473':'GRD','474':'CAN',
    '475':'CT','478':'GA','479':'AR','480':'AZ','483':'AL','484':'PA','501':'AR','502':'KY','503':'OR',
    '504':'LA','505':'NM','506':'CAN','507':'MN','508':'MA','509':'WA','510':'CA','512':'TX','513':'OH',
    '514':'CAN','515':'IA','516':'NY','517':'MI','518':'NY','519':'CAN','520':'AZ','530':'CA','531':'NE',
    '534':'WI','539':'OK','540':'VA','541':'OR','548':'CAN','551':'NJ','557':'MO','559':'CA','561':'FL',
    '562':'CA','563':'IA','564':'WA','567':'OH','570':'PA','571':'VA','572':'OK','573':'MO','574':'IN',
    '575':'NM','579':'CAN','580':'OK','581':'CAN','582':'PA','584':'CAN','585':'NY','586':'MI','587':'CAN',
    '601':'MS','602':'AZ','603':'NH','604':'CAN','605':'SD','606':'KY','607':'NY','608':'WI','609':'NJ',
    '610':'PA','612':'MN','613':'CAN','614':'OH','615':'TN','616':'MI','617':'MA','618':'IL','619':'CA',
    '620':'KS','621':'TX','623':'AZ','624':'NY','626':'CA','628':'CA','629':'TN','630':'IL','631':'NY',
    '636':'MO','639':'CAN','640':'NJ','641':'IA','645':'FL','646':'NY','647':'CAN','650':'CA','651':'MN',
    '656':'FL','657':'CA','659':'AL','660':'MO','661':'CA','662':'MS','667':'MD','669':'CA','671':'GUM',
    '672':'CAN','678':'GA','679':'MI','680':'NY','681':'WV','682':'TX','683':'CAN','684':'AS','686':'VA',
    '689':'FL','701':'ND','702':'NV','703':'VA','704':'NC','705':'CAN','706':'GA','707':'CA','708':'IL',
    '709':'CAN','712':'IA','713':'TX','714':'CA','715':'WI','716':'NY','717':'PA','718':'NY','719':'CO',
    '720':'CO','724':'PA','725':'NV','726':'TX','727':'FL','728':'FL','729':'TN','730':'IL','731':'TN',
    '732':'NJ','734':'MI','737':'TX','738':'CA','740':'OH','742':'CAN','743':'NC','747':'CA','748':'CO',
    '753':'CAN','754':'FL','757':'VA','760':'CA','762':'GA','763':'MN','765':'IN','769':'MS','770':'GA',
    '771':'DC','772':'FL','773':'IL','774':'MA','775':'NV','778':'CAN','779':'IL','780':'CAN','781':'MA',
    '782':'CAN','785':'KS','786':'FL','787':'PR','801':'UT','802':'VT','803':'SC','804':'VA','805':'CA',
    '806':'TX','807':'CAN','808':'HI','810':'MI','812':'IN','813':'FL','814':'PA','815':'IL','816':'MO',
    '817':'TX','818':'CA','819':'CAN','820':'CA','821':'SC','825':'CAN','826':'VA','828':'NC','830':'TX',
    '831':'CA','832':'TX','835':'PA','837':'CA','838':'NY','839':'SC','840':'CA','843':'SC','845':'NY',
    '847':'IL','848':'NJ','850':'FL','854':'SC','856':'NJ','857':'MA','858':'CA','859':'KY','860':'CT',
    '861':'IL','862':'NJ','863':'FL','864':'SC','865':'TN','867':'CAN','870':'AR','872':'IL','873':'CAN',
    '878':'PA','879':'CAN','901':'TN','902':'CAN','903':'TX','904':'FL','905':'CAN','906':'MI','907':'AK',
    '908':'NJ','909':'CA','910':'NC','912':'GA','913':'KS','914':'NY','915':'TX','916':'CA','917':'NY',
    '918':'OK','919':'NC','920':'WI','924':'MN','925':'CA','928':'AZ','929':'NY','930':'IN','931':'TN',
    '934':'NY','936':'TX','937':'OH','938':'AL','939':'PR','940':'TX','941':'FL','942':'CAN','943':'GA',
    '945':'TX','947':'MI','948':'VA','949':'CA','951':'CA','952':'MN','954':'FL','956':'TX','959':'CT',
    '970':'CO','971':'OR','972':'TX','973':'NJ','975':'MO','978':'MA','979':'TX','980':'NC','983':'CO',
    '984':'NC','985':'LA','986':'ID','989':'MI'
  };
  function stateFor(code) {
    if (!code) return '';
    var up = String(code).toUpperCase();
    if (up === 'RTC') return '';   // RTC-branded products: no state prefix
    return AC[up] || '';
  }
  function updateBadges(root) {
    (root || document).querySelectorAll('.rtc-code-badge[data-area-code]').forEach(function(el){
      if (el.dataset.rtcBadgeStateApplied === '1') return;
      var code = el.getAttribute('data-area-code') || '';
      var st = stateFor(code);
      el.textContent = st ? (st + '-' + code) : code;
      el.dataset.rtcBadgeStateApplied = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ updateBadges(); });
  } else {
    updateBadges();
  }
  ['theme:cart:change','theme:cart:refresh','shopify:section:load'].forEach(function(ev){
    document.addEventListener(ev, function(){ updateBadges(); });
  });
  if (window.MutationObserver) {
    var mo2 = new MutationObserver(function(muts){
      var added = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length > 0) { added = true; break; }
      }
      if (added) updateBadges();
    });
    mo2.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* RTC Peek — mobile toggle button ("+") injected into each card's image */
(function(){
  function injectToggle(root) {
    (root || document).querySelectorAll('.product-item__image').forEach(function(imgWrap) {
      if (imgWrap.querySelector('.rtc-peek-toggle')) return; // already added
      // Only inject if this card has a peek panel
      var card = imgWrap.closest('.product-item');
      if (!card || !card.querySelector('.rtc-peek')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rtc-peek-toggle';
      btn.setAttribute('aria-label', 'Show variants');
      btn.textContent = '+';
      imgWrap.appendChild(btn);
    });
  }
  function scan(root) { injectToggle(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });

  // Click handler: toggle + tap-outside closes
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.rtc-peek-toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var card = toggle.closest('.product-item');
      // Close any OTHER peeked cards first
      document.querySelectorAll('.product-item.is-peeked').forEach(function(c) {
        if (c !== card) c.classList.remove('is-peeked');
      });
      card.classList.toggle('is-peeked');
      return;
    }
    // Tap outside any peeked card = close all
    if (!e.target.closest('.product-item.is-peeked .rtc-peek') &&
        !e.target.closest('.rtc-peek-toggle')) {
      document.querySelectorAll('.product-item.is-peeked').forEach(function(c) {
        c.classList.remove('is-peeked');
      });
    }
  }, true);

  // MutationObserver — inject buttons for AJAX-added cards
  if (window.MutationObserver) {
    var mo3 = new MutationObserver(function(muts){
      var hasAdds = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length > 0) { hasAdds = true; break; }
      }
      if (hasAdds) requestAnimationFrame(function(){ injectToggle(); });
    });
    mo3.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* RTC Peek — dedicated size-button click handler.
   Adds to cart directly, opens cart drawer, shows Added feedback.
   Runs BEFORE the theme's data-rtc-size-btn handler and stops the event
   so the theme handler doesn't double-fire. */
(function(){
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('[data-rtc-peek-size]');
    if (!sizeBtn) return;
    // Ignore clicks on disabled / already-adding buttons
    if (sizeBtn.disabled || sizeBtn.classList.contains('is-adding') || sizeBtn.classList.contains('is-hidden')) {
      e.preventDefault(); e.stopPropagation(); return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();  // stop the theme's handler from also firing

    var variantId = sizeBtn.getAttribute('data-variant-id');
    if (!variantId) { console.warn('RTC peek size: no variant id'); return; }
    var peek = sizeBtn.closest('[data-rtc-peek]');
    var addedEl = peek && peek.querySelector('[data-rtc-peek-added]');

    sizeBtn.classList.add('is-adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err){ throw err; });
      return res.json();
    })
    .then(function() {
      sizeBtn.classList.remove('is-adding');
      // Show Added feedback in the peek
      if (addedEl) {
        addedEl.classList.add('is-visible');
        setTimeout(function(){ addedEl.classList.remove('is-visible'); }, 1600);
      }
      // Update cart count in header
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          document.querySelectorAll('[data-cart-count]').forEach(function(el){
            el.textContent = cart.item_count;
            el.setAttribute('data-cart-count', cart.item_count);
          });
          document.querySelectorAll('.header__cart__count').forEach(function(b){
            b.textContent = cart.item_count;
          });
        });
      // Refresh cart drawer contents + open it
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      setTimeout(function(){
        document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
      }, 250);
      // Close the peek shortly after
      setTimeout(function(){
        var card = sizeBtn.closest('.product-item');
        if (card) card.classList.remove('is-peeked');
      }, 1600);
    })
    .catch(function(err) {
      sizeBtn.classList.remove('is-adding');
      console.error('RTC peek add-to-cart failed:', err);
      // Still try to open drawer / show error UX if the theme supports it
    });
  }, true);
})();
